let SelectAvatar = ({ selectPic, profilePic, setProfilePic }) => {
  return (
    <div className="single-form-element select-avatar-area">
      <div className="avatar-element">
        <input
          id="avatar1"
          name="avatar"
          type="radio"
          value="https://ik.imagekit.io/1u3yre5td/avatar/avatar1.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677335397598"
          onChange={selectPic}
        />
        <label
          htmlFor="avatar1"
          style={{
            background: `url("https://ik.imagekit.io/1u3yre5td/avatar/avatar1.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677335397598")`,
          }}
        ></label>
      </div>

      <div className="avatar-element">
        <input
          id="avatar2"
          name="avatar"
          type="radio"
          value="https://ik.imagekit.io/1u3yre5td/avatar/avatar2.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677335397895"
          onChange={selectPic}
        />
        <label
          htmlFor="avatar2"
          style={{
            background: `url("https://ik.imagekit.io/1u3yre5td/avatar/avatar2.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677335397895")`,
          }}
        ></label>
      </div>

      <div className="avatar-element">
        <input
          id="avatar3"
          name="avatar"
          type="radio"
          value="https://ik.imagekit.io/1u3yre5td/avatar/avatar3.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677335397393"
          onChange={selectPic}
        />
        <label
          htmlFor="avatar3"
          style={{
            background: `url("https://ik.imagekit.io/1u3yre5td/avatar/avatar3.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677335397393")`,
          }}
        ></label>
      </div>

      <div className="avatar-element">
        <input
          id="avatar4"
          name="avatar"
          type="radio"
          value="https://ik.imagekit.io/1u3yre5td/avatar/avatar4.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677335398649"
          onChange={selectPic}
        />
        <label
          htmlFor="avatar4"
          style={{
            background: `url("https://ik.imagekit.io/1u3yre5td/avatar/avatar4.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677335398649")`,
          }}
        ></label>
      </div>
    </div>
  );
};

export default SelectAvatar;
